import styled from 'styled-components';
import { H2, SubH } from '../style/typography';
import { colors } from '../style/colors';
import { min, max } from '../lib/responsive';

const ContentSectionWrapper = styled.section`
  position: relative;
  padding-bottom: 10rem;
  @media ${min.tabletSm} {
    padding-bottom: 15rem;
  }
  @media ${min.tablet} {
    padding-bottom: 20rem;
  }
  @media ${min.tabletLg} {
    padding: 5rem 0;
  }
`;

const DateText = styled(H2)`
  color: ${colors.PINK};
  font-size: clamp(2em, 14vw, 14em);
  margin-bottom: 1rem;
  padding: 2rem;
  @media ${min.tabletLg} {
    padding: 5.5rem;
  }
`;

const DateContainer = styled.div`
  @media ${max.tabletSm} {
    margin-left: 0;
  }
  background-color: ${colors.MINT};
  transform: rotate(-5deg);
  z-index: 10;
  margin-left: clamp(2rem, 20vw, 25rem);
  text-align: center;
`;

const DateWrapper = styled.div`
  overflow: hidden;
  padding: 0;
  @media ${min.tablet} {
    margin-bottom: -5rem;
  }

  @media ${min.desktop} {
    margin-bottom: -8rem;
    margin-top: -15rem;
  }
`;

const LocationText = styled(H2)`
  color: ${colors.RED};
  margin: 0;
  font-size: clamp(2em, 14vw, 14em);
  padding: 2rem;

  @media ${min.tabletLg} {
    padding: 5.5rem;
  }
`;

const AddressText = styled(SubH)`
  margin: auto 0;
  font-size: 0.5em;
  padding: 2.5rem;
  padding-left: 0;
  color: ${colors.BLACK};
  font-size: clamp(0.5em, 2.5vw, 1em);
  width: 40%;
  @media ${min.tabletSm} {
    width: 15rem;
  }
  @media ${min.tablet} {
    width: 20rem;
    padding-left: 6rem;
    font-size: 1.3em;
    padding: 2rem;
    color: ${colors.RED};
  }

  @media ${min.tabletLg} {
    width: 25rem;
    font-size: 1.8em;
    padding: 5.5rem 0;
  }
`;

const LocationContainer = styled.div`
  background-color: ${colors.TAN};
  z-index: 5;
  transform: rotate(3.58deg);
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: 4rem;
  margin-top: -1rem;
  margin-bottom: 5rem;
  @media ${max.tabletSm} {
    margin-left: 0;
    margin-bottom: 1rem;
  }
  @media ${min.tabletSm} {
    margin-bottom: 3rem;
  }
`;

const Circles = styled.img`
  z-index: -1;
  position: absolute;
  width: 20rem;
  margin-top: -12rem;
  right: -5.5rem;

  @media ${min.tabletSm} {
    width: 25rem;
    right: -7rem;
    margin-top: -15rem;
  }
  @media ${min.tablet} {
    width: 30rem;
  }
  @media ${min.tabletLg} {
    right: 3rem;
    width: 35rem;
  }
  @media ${min.desktop} {
    width: 34rem;
    margin-top: -10rem;
    right: 0;
  }
  @media ${min.desktopLg} {
    width: 35rem;
  }
`;

const Mic = styled.img`
  z-index: 3;
  position: absolute;
  transform: rotate(18deg);
  width: 3.5rem;
  top: 67%;
  right: 0;

  @media ${min.tabletSm} {
    width: 5rem;
    top: 48%;
  }

  @media ${min.tablet} {
    right: 2.3rem;
  }

  @media ${min.tabletLg} {
    transform: rotate(0deg);
    width: 10.5rem;
    top: 0;
    right: 15.5rem;
  }

  @media ${min.desktop} {
    width: 8.5rem;
    right: 13rem;
  }

  @media ${min.desktopLg} {
    width: 7.5rem;
    right: 14rem;
  }
`;

const PageContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

export {
  ContentSectionWrapper,
  LocationText,
  DateText,
  AddressText,
  DateContainer,
  LocationContainer,
  Circles,
  Mic,
  DateWrapper,
  PageContainer,
};
